import ProductPageSocialProofSection from './ProductPageSocialProofSection'

export default ProductPageSocialProofSection
